import React, {Component} from 'react';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {reverseParseTextView} from './createRender';
import {Rate,Tooltip, Row, Col} from 'antd'
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';


const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        this.setState({visible: val});
    };

    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
        let data = reverseParseTextView(this.props.data);
        this.props.getDate && this.props.getDate(data);
    }
    componentDidUpdate(preProps) {
        if (preProps.data.question_id !== this.props.data.question_id) {
            let data = reverseParseTextView(this.props.data);
            this.props.getDate && this.props.getDate(data);
        }

        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', (d) => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }


    createHtml = str => ({__html: str ? str : `&nbsp;`});

    render() {
        const {visible,} = this.state;
        let originData = this.props.data;
        
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案
        const {num='undefined', children,canShowAnswer} = this.props;
        let data = reverseParseTextView(originData);
        const { blanklist, imgDetail, ruleList, stem, fillableValue, ruleDisplay } = data;

        return (
            <div className="box-exercise" ref={'viewer'}>
                {/*<div className="box-exercise" ref={(el) => {this.viewer = el}}>*/}
                 <div className="exercise-content">
                     {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    <div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(stem)}/>
                    <div className="footer-equation">
                        <div className="blank-detail-border" style={{border: '2px dashed rgb(153, 153, 153)', padding: '10px', display: 'inline-block'}}>
                            <div className="blank-detail" style={{width:'510px'}}>
                                {/* <img style={{width: imgDetail.imgWidth, height: imgDetail.imgHeight}} src={imgDetail.imgUrl} title="挖空图片" /> */}
                                <img  src={imgDetail.imgUrl} title="挖空图片" />
                                {
                                    blanklist.length > 0 && blanklist.map((item, index) => 
                
                                        <span className={item.lock ? `determined-value empty-item ${item.size}` : `empty-item ${item.size}`} style={{position: 'absolute', left: item.x_pos*0.75, top: item.y_pos*0.75}} key={index}>{visible ? item.value  : `空${index+1}`}</span>
                                    )       
                                }
                            </div>
                        </div>
                        <Row type="flex" align="middle">
                            <Col span={6}>
                                <p className="equation-answer-item">初始值：</p>
                            </Col>
                            <Col span={18} className="equation-answer-list">
                                {
                                    blanklist.length > 0 && blanklist.map((item, index) => {
                                        if (item.lock) {
                                            return (
                                                <span key={index}>空{index+1}:  {item.value}</span>
                                            )
                                        }
                                    })
                                }
                            </Col>
                        </Row>
                        {
                            ruleDisplay.length > 0 && ruleDisplay.map((value, index) => 
                                <Row type="flex" align="middle" key={index} className="rule-display">
                                    <Col span={4}>
                                        <p className="equation-answer-item">规则{index+1}：</p>
                                    </Col>
                                    <Col span={8} className="equation-answer-list">
                                        <p>{value}</p>
                                    </Col>
                                    <Col span={8}>
                                        <p className="equation-answer-item">规则等于值{index+1}：</p>
                                    </Col>
                                    <Col className="equation-answer-list" span={4}>
                                        <p>{ruleList[index].value}</p>
                                    </Col>
                                </Row>
                            )
                        }
                    </div>
                </div>

                <div className="exercise-footer">
                    {
                        visible && 
                        <div className="footer-hide relative" style={{fontSize: '14px'}}>
                            <Row>
                                <Col>正确答案：</Col>
                            </Row>
                        </div>
                        
                    }

                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={() => this.toggleAnswer(!visible)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/numMatrix/viewForView.js